module.exports = __webpack_public_path__ + "static/call-d73bf2cad7c418d098cf598fef7b291d.svg";